import request from '../../../utils/requests'

/**
 * Tag: CoachHomeMenu
 */

const baseUrl ="/api/Coach/HomeMenu";



/**
 * 获取首页菜单
 * @param {*} param
 * {
 *    hasDefault Desc: Required:false
 * }
 */
async function _getHomeMenu(param) {
  return request(baseUrl+'/getHomeMenu',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取首页菜单配置
 */
async function _getAllHomeMenu() {
  return request(baseUrl+'/getAllHomeMenu',{
    method: 'GET',
  });

}



/**
 * 保存首页菜单
 * @param {*} body
 * {
 *    menuList Desc: Required:true
 * }
 */
async function _save(body) {
  return request(baseUrl+'/save',{
    method: 'POST',
    body: body,
  });

}



export default{
  _getHomeMenu,
  _getAllHomeMenu,
  _save
}




// WEBPACK FOOTER //
// ./src/services/coach/homeMenu.js